import { inject, Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';

@Injectable()
export class AppTitleStrategy extends TitleStrategy {
    private readonly titleService = inject(Title);

    override updateTitle(snapshot: RouterStateSnapshot) {
        const data = snapshot.root.firstChild?.data;

        if (data?.['entityData']) {
            const property = (data['property'] as string) ?? 'name';
            const entityData = data['entityData'];
            const title = entityData[property] ?? 'CRM';
            this.titleService.setTitle(title);
            return;
        }

        const title = this.buildTitle(snapshot) ?? 'CRM';
        this.titleService.setTitle(title);
    }
}
